import { useMutation } from '@tanstack/react-query';

import { artiaProtectedApi } from '@/lib/api-client';

// Types
export type MeetingPrepRequest = {
  meetingId: number;
};

export type MeetingPrepBriefResponse = {
  meetingId: number;
  meetingSummary: string;
  brief: string;
  generatedAt: string;
};

export type AskRequest = {
  question: string;
  conversationId?: string;
};

export type AskResponse = {
  answer: string;
  conversationId: string;
  generatedAt: string;
};

// API calls
const generateMeetingPrep = async (request: MeetingPrepRequest): Promise<MeetingPrepBriefResponse> => {
  return artiaProtectedApi.post('ai/meeting-prep', request);
};

const askQuestion = async (request: AskRequest): Promise<AskResponse> => {
  return artiaProtectedApi.post('ai/ask', request);
};

// Mutation hooks
export const useMeetingPrepMutation = () => {
  return useMutation({
    mutationFn: generateMeetingPrep,
  });
};

export const useAskMutation = () => {
  return useMutation({
    mutationFn: askQuestion,
  });
};

// Drug Intelligence Types
export type DrugSummaryRequest = {
  drugId: number;
};

export type DrugSummaryResponse = {
  drugId: number;
  drugName: string;
  summary: string;
  generatedAt: string;
};

export type DrugBriefRequest = {
  drugId: number;
};

export type DrugBriefResponse = {
  drugId: number;
  drugName: string;
  brief: string;
  generatedAt: string;
};

// Drug Intelligence API calls
const generateDrugSummary = async (request: DrugSummaryRequest): Promise<DrugSummaryResponse> => {
  return artiaProtectedApi.post('ai/drug-summary', request);
};

const generateDrugBrief = async (request: DrugBriefRequest): Promise<DrugBriefResponse> => {
  return artiaProtectedApi.post('ai/drug-brief', request);
};

// Drug Intelligence Mutation hooks
export const useDrugSummaryMutation = () => {
  return useMutation({
    mutationFn: generateDrugSummary,
  });
};

export const useDrugBriefMutation = () => {
  return useMutation({
    mutationFn: generateDrugBrief,
  });
};
